import { render, staticRenderFns } from "./NodalPCTabular.vue?vue&type=template&id=76b4542c&"
import script from "./NodalPCTabular.vue?vue&type=script&lang=js&"
export * from "./NodalPCTabular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b4542c')) {
      api.createRecord('76b4542c', component.options)
    } else {
      api.reload('76b4542c', component.options)
    }
    module.hot.accept("./NodalPCTabular.vue?vue&type=template&id=76b4542c&", function () {
      api.rerender('76b4542c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/NodalPCTabular.vue"
export default component.exports